// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jh-0";
export var fileCarousel = "_jh-2";
export var removeFileButton = "_jh-1";